const flatten_ = require('lodash/flatten')

const {
  selectNextDynamicPageUrl,
  selectPreviousDynamicPageUrl
} = require('./reducer')

const {
  getNextDynamicPageCmd,
  getPreviousDynamicPageCmd
} = require('./executor')

const shouldLoadNextDynamicPageUrl = state => {
  return selectNextDynamicPageUrl(state).shouldLoadUrl()
}

const shouldLoadPreviousDynamicPageUrl = state => {
  return selectPreviousDynamicPageUrl(state).shouldLoadUrl()
}

const subscriber = () => {
  const processDynamicPagesStates = ({ hasChangedToTrue }) => {
    const commandsToReturn = []

    if (hasChangedToTrue(shouldLoadNextDynamicPageUrl)) {
      commandsToReturn.push(getNextDynamicPageCmd())
    }
    if (hasChangedToTrue(shouldLoadPreviousDynamicPageUrl)) {
      commandsToReturn.push(getPreviousDynamicPageCmd())
    }

    return commandsToReturn
  }

  return transition =>
    flatten_([processDynamicPagesStates].map(fn => fn(transition)))
}

module.exports = subscriber



// WEBPACK FOOTER //
// ./dynamic-pages/subscriber.js